import { useFileSignedUrl } from "@/api/services/global/file";
import { useSharedFileSignedUrl } from "@/api/services/main/sharing";
import { Avatar } from "@mui/material";
import { FC } from "react";

type Props = {
  filePath?: string | null;
  name?: string;
  size?: number;
  shareUrl?: string;
};

// Small circular avatar for use in table cells
export const TalentAvatarCell: FC<Props> = ({ filePath, name, size = 24, shareUrl }) => {
  const { data: authData } = useFileSignedUrl(!shareUrl ? filePath : undefined);
  const { data: sharedData } = useSharedFileSignedUrl(shareUrl ? filePath : undefined, shareUrl);
  const signedUrl = authData?.data?.signedUrl || sharedData?.data?.signedUrl;
  const initials = name?.charAt(0) || "";

  return (
    <Avatar src={signedUrl || undefined} alt={name || ""} sx={{ width: size, height: size, fontSize: size * 0.45, flexShrink: 0 }}>
      {initials}
    </Avatar>
  );
};
